<template>
  <div class="logo-animation">
    <svg
      :class="{ 'active' : active }"
      width="100%"
      viewBox="0 0 643 168"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M269.651 69.085L269.649 69.0808C267.69 65.0634 266.7 60.2418 266.7 54.7C266.7 49.259 267.689 44.4372 269.649 40.4192C271.612 36.3959 274.349 33.2741 277.956 31.1298C281.566 28.9827 285.775 27.9 290.8 27.9C294.15 27.9 297.291 28.3926 300.228 29.4694C303.174 30.5498 305.71 32.0158 307.851 34.0576C308.579 34.7877 308.9 35.4662 308.9 36.3C308.9 36.8838 308.739 37.3837 308.396 37.9043C308.057 38.3216 307.692 38.5 307.4 38.5C306.95 38.5 306.362 38.2713 305.475 37.7808C302.868 35.7778 300.533 34.3538 298.378 33.5328C296.211 32.7072 293.749 32.3 291 32.3C285.08 32.3 280.429 34.2457 277.118 38.1779C273.813 42.1026 272.3 47.6369 272.3 54.7C272.3 61.8695 273.915 67.3969 277.113 71.3161C280.327 75.2563 284.984 77.2 291 77.2C293.749 77.2 296.211 76.7928 298.378 75.9672C300.532 75.1466 302.971 73.7214 305.495 71.7043C306.327 71.153 306.927 71 307.4 71C307.782 71 308.053 71.1669 308.41 71.6124C308.727 72.009 308.9 72.4932 308.9 73.2C308.9 74.0538 308.564 74.8173 307.871 75.4237L307.871 75.4236L307.864 75.43C305.711 77.3866 303.167 78.9528 300.228 80.0306C297.291 81.1074 294.15 81.6 290.8 81.6C285.874 81.6 281.566 80.5168 277.956 78.3702C274.346 76.2238 271.611 73.2009 269.651 69.085Z"
          fill="white"
          stroke="white"
          class="svg-elem-1"
        ></path>
        <path
          d="M365.262 79.9077L365.262 79.9077L365.258 79.899L359.858 67.599L359.727 67.3H359.4H330.9H330.573L330.442 67.599L325.042 79.899L325.042 79.899L325.038 79.9077C324.818 80.4357 324.524 80.8018 324.18 81.0376C323.837 81.2727 323.414 81.4 322.9 81.4C322.235 81.4 321.645 81.1537 321.12 80.7159C320.637 80.3135 320.4 79.7558 320.4 79.2C320.4 78.8864 320.478 78.5625 320.647 78.2236L320.652 78.2143L320.656 78.2048L342.256 30.1048L342.256 30.1049L342.26 30.097C342.511 29.5108 342.932 29.0794 343.477 28.716C343.957 28.3962 344.54 28.3 345.2 28.3C345.898 28.3 346.402 28.469 346.923 28.816C347.468 29.1794 347.889 29.6108 348.14 30.197L348.14 30.197L348.144 30.2044L369.644 78.2044L369.648 78.2141L369.653 78.2236C369.822 78.5625 369.9 78.8864 369.9 79.2C369.9 79.8447 369.671 80.3064 369.18 80.7159C368.655 81.1537 368.065 81.4 367.4 81.4C366.83 81.4 366.412 81.2697 366.088 81.0415C365.762 80.811 365.487 80.4488 365.262 79.9077ZM332.743 62.4976L332.432 63.2H333.2H357.2H357.968L357.657 62.4976L345.657 35.3976L345.2 34.3651L344.743 35.3976L332.743 62.4976Z"
          fill="white"
          stroke="white"
          class="svg-elem-2"
        ></path>
        <path
          d="M388.1 81.4C387.329 81.4 386.766 81.1502 386.369 80.7621C385.946 80.2478 385.7 79.6637 385.7 78.9V31C385.7 30.1299 385.951 29.5459 386.37 29.0376C386.866 28.5481 387.433 28.3 388.3 28.3C388.854 28.3 389.324 28.447 389.732 28.7423C390.145 29.0418 390.522 29.5152 390.847 30.2114L390.852 30.2215L390.857 30.2313L410.057 67.0313L410.502 67.8854L410.944 67.0294L429.944 30.2294L429.944 30.2294L429.947 30.2236C430.345 29.4272 430.692 28.9479 431.057 28.7287C431.504 28.461 431.915 28.3 432.5 28.3C433.367 28.3 433.934 28.5481 434.43 29.0376C434.849 29.5459 435.1 30.1299 435.1 31V78.9C435.1 79.6725 434.848 80.2613 434.416 80.7799C434.051 81.2177 433.529 81.4 432.7 81.4C431.904 81.4 431.369 81.136 431.09 80.7877L431.091 80.7876L431.084 80.7799C430.679 80.2934 430.5 79.7181 430.5 78.9V40.2L429.557 39.9691L413.157 71.4691L413.152 71.4787L413.147 71.4886C412.822 72.1847 412.446 72.6558 412.024 72.9543C411.607 73.249 411.111 73.4 410.5 73.4C409.947 73.4 409.474 73.2535 409.051 72.9543C408.621 72.6501 408.217 72.1698 407.841 71.4652C407.841 71.465 407.841 71.4649 407.841 71.4647L391.342 40.3657L390.4 40.6V78.9C390.4 79.7181 390.221 80.2934 389.816 80.7799C389.451 81.2177 388.929 81.4 388.1 81.4Z"
          fill="white"
          stroke="white"
          class="svg-elem-3"
        ></path>
        <path
          d="M456.084 80.6799L456.07 80.6625L456.054 80.6465C455.58 80.1733 455.4 79.6229 455.4 78.7V31.2C455.4 30.4324 455.647 29.8596 456.154 29.3536C456.627 28.8804 457.177 28.7 458.1 28.7H476C481.518 28.7 485.688 30.0783 488.672 32.677C491.641 35.2632 493.2 39.0132 493.2 43.9C493.2 48.7869 491.641 52.5368 488.672 55.123L488.672 55.1229L488.665 55.129C485.684 57.8211 481.419 59.2 476 59.2H461H460.5V59.7V78.8C460.5 79.6701 460.249 80.2541 459.83 80.7624C459.339 81.2467 458.779 81.4947 457.928 81.4999C457.103 81.4039 456.462 81.134 456.084 80.6799ZM461 32.8H460.5V33.3V54.5V55H461H475.3C479.414 55 482.603 54.0871 484.767 52.1884C486.944 50.2789 488 47.4471 488 43.8C488 40.2005 486.942 37.4172 484.763 35.5457C482.599 33.6866 479.411 32.8 475.3 32.8H461Z"
          fill="white"
          stroke="white"
          class="svg-elem-4"
        ></path>
        <path
          d="M510.884 80.6799L510.87 80.6625L510.854 80.6465C510.38 80.1733 510.2 79.6229 510.2 78.7V31C510.2 30.1299 510.451 29.5459 510.87 29.0376C511.366 28.5481 511.933 28.3 512.8 28.3C513.676 28.3 514.246 28.5535 514.746 29.0536C515.22 29.5267 515.4 30.0771 515.4 31V78.7C515.4 79.5701 515.149 80.1541 514.73 80.6624C514.234 81.1519 513.667 81.4 512.8 81.4C511.894 81.4 511.259 81.1299 510.884 80.6799Z"
          fill="white"
          stroke="white"
          class="svg-elem-5"
        ></path>
        <path
          d="M541.3 38.3006L540.4 37.0962V38.6V78.7C540.4 79.5801 540.143 80.1675 539.716 80.6799C539.331 81.1414 538.787 81.4 537.9 81.4C537.123 81.4 536.574 81.1478 536.184 80.6799C535.757 80.1675 535.5 79.5802 535.5 78.7V31C535.5 30.1198 535.757 29.5325 536.184 29.0201C536.564 28.5646 537.203 28.3 538 28.3C538.846 28.3 539.599 28.6292 540.202 29.403L571.499 71.3988L572.4 72.6077V71.1V31C572.4 30.1198 572.657 29.5325 573.084 29.0201C573.469 28.5587 574.013 28.3 574.9 28.3C575.35 28.3 575.677 28.3675 575.934 28.4819C576.189 28.5949 576.405 28.7667 576.616 29.0201C577.043 29.5325 577.3 30.1198 577.3 31V78.7C577.3 79.5802 577.043 80.1675 576.616 80.6799C576.236 81.1354 575.597 81.4 574.8 81.4C573.971 81.4 573.312 81.0847 572.697 80.2967L541.3 38.3006Z"
          fill="white"
          stroke="white"
          class="svg-elem-6"
        ></path>
        <path
          d="M636.356 78.7211L636.325 78.7305L636.295 78.744C634.353 79.6177 631.904 80.2093 629.113 80.7076C626.234 81.2039 623.464 81.5 620.6 81.5C615.369 81.5 610.859 80.4145 607.151 78.2673C603.433 76.1147 600.504 73.0873 598.549 69.0808C596.587 65.0585 595.5 60.2352 595.5 54.6C595.5 49.0598 596.489 44.3377 598.449 40.3192C600.406 36.3074 603.238 33.2823 606.951 31.1327C610.664 28.9831 614.975 27.9 620 27.9C623.453 27.9 626.693 28.3934 629.628 29.4694C632.58 30.5517 635.106 32.0162 637.038 34.0448L637.038 34.0449L637.046 34.0536C637.892 34.8991 638.2 35.5794 638.2 36.3C638.2 36.8837 638.039 37.3837 637.696 37.9042C637.368 38.3078 637.004 38.5 636.6 38.5C636.16 38.5 635.567 38.275 634.802 37.7018C632.178 35.6832 629.736 34.2549 627.578 33.4328C625.409 32.6065 622.846 32.2 620.1 32.2C613.986 32.2 609.232 34.1417 605.918 38.0779C602.615 41.9994 601 47.5308 601 54.7C601 61.9619 602.612 67.6025 606.025 71.4303C609.445 75.3672 614.3 77.2 620.7 77.2C625.451 77.2 629.709 76.4921 633.669 75.0706L634 74.9518V74.6V58.6V58.1H633.5H622.5C621.687 58.1 621.232 57.9245 620.854 57.5464C620.408 57.101 620.2 56.7206 620.2 56.2C620.2 55.5785 620.412 55.2008 620.833 54.774C621.219 54.4752 621.789 54.3 622.5 54.3H636.6C637.294 54.3 637.773 54.4668 638.166 54.7732C638.536 55.1528 638.7 55.6086 638.7 56.3V75.1C638.7 76.2602 638.504 77.043 638.184 77.5227C637.864 78.0031 637.274 78.4457 636.356 78.7211Z"
          fill="white"
          stroke="white"
          class="svg-elem-7"
        ></path>
        <path
          d="M357.461 163.373L357.461 163.373L357.456 163.37C353.849 161.226 351.115 158.106 349.254 154.09C347.389 150.066 346.4 145.339 346.4 139.9C346.4 134.362 347.388 129.634 349.255 125.508C351.116 121.493 353.85 118.374 357.456 116.23C361.067 114.082 365.276 113 370.2 113C375.124 113 379.333 114.082 382.944 116.23C386.555 118.376 389.286 121.397 391.144 125.506L391.146 125.51C393.011 129.534 394 134.26 394 139.8C394 145.239 393.011 150.063 391.148 154.085C389.186 158.106 386.449 161.228 382.942 163.372C379.33 165.519 375.122 166.6 370.3 166.6C365.173 166.6 360.967 165.516 357.461 163.373ZM383.682 156.422L383.682 156.422L383.687 156.416C386.885 152.497 388.5 146.97 388.5 139.8C388.5 132.631 386.885 127.103 383.687 123.184C380.476 119.248 375.923 117.3 370.1 117.3C364.374 117.3 359.825 119.25 356.518 123.178C353.213 127.103 351.7 132.637 351.7 139.7C351.7 146.773 353.317 152.295 356.509 156.311L356.509 156.311L356.513 156.316C359.723 160.251 364.275 162.199 370.096 162.2C375.826 162.301 380.375 160.349 383.682 156.422Z"
          fill="white"
          stroke="white"
          class="svg-elem-8"
        ></path>
        <path
          d="M417.8 123.301L416.9 122.096V123.6V163.7C416.9 164.58 416.643 165.168 416.216 165.68C415.831 166.141 415.287 166.4 414.4 166.4C413.623 166.4 413.074 166.148 412.684 165.68C412.257 165.168 412 164.58 412 163.7V116C412 115.12 412.257 114.532 412.684 114.02C413.064 113.565 413.703 113.3 414.5 113.3C415.346 113.3 416.099 113.629 416.702 114.403L447.999 156.399L448.9 157.608V156.1V116C448.9 115.12 449.157 114.532 449.584 114.02C449.969 113.559 450.513 113.3 451.4 113.3C452.177 113.3 452.726 113.552 453.116 114.02C453.543 114.532 453.8 115.12 453.8 116V163.7C453.8 164.58 453.543 165.168 453.116 165.68C452.736 166.135 452.097 166.4 451.3 166.4C450.471 166.4 449.812 166.085 449.197 165.297L417.8 123.301Z"
          fill="white"
          stroke="white"
          class="svg-elem-9"
        ></path>
        <path
          d="M504.1 166.1H476.532C475.837 166.008 475.237 165.746 474.72 165.316C474.252 164.926 474 164.377 474 163.6V116C474 115.13 474.251 114.546 474.67 114.038C475.166 113.548 475.733 113.3 476.6 113.3C477.476 113.3 478.046 113.553 478.546 114.054C479.02 114.527 479.2 115.077 479.2 116V161.2V161.7H479.7H504.1C504.932 161.7 505.478 161.885 505.846 162.254C506.257 162.664 506.5 163.138 506.5 163.9C506.5 164.662 506.257 165.136 505.846 165.546C505.478 165.915 504.932 166.1 504.1 166.1Z"
          fill="white"
          stroke="white"
          class="svg-elem-10"
        ></path>
        <path
          d="M521.554 165.646C521.08 165.173 520.9 164.623 520.9 163.7V116C520.9 115.13 521.151 114.546 521.57 114.038C522.066 113.548 522.633 113.3 523.5 113.3C524.376 113.3 524.946 113.553 525.446 114.054C525.92 114.527 526.1 115.077 526.1 116V163.7C526.1 164.57 525.849 165.154 525.43 165.662C524.934 166.152 524.367 166.4 523.5 166.4C522.624 166.4 522.054 166.147 521.554 165.646Z"
          fill="white"
          stroke="white"
          class="svg-elem-11"
        ></path>
        <path
          d="M552.1 123.301L551.2 122.096V123.6V163.7C551.2 164.58 550.943 165.168 550.516 165.68C550.131 166.141 549.587 166.4 548.7 166.4C547.923 166.4 547.374 166.148 546.984 165.68C546.557 165.168 546.3 164.58 546.3 163.7V116C546.3 115.12 546.557 114.532 546.984 114.02C547.364 113.565 548.003 113.3 548.8 113.3C549.646 113.3 550.399 113.629 551.002 114.403L582.299 156.399L583.2 157.608V156.1V116C583.2 115.12 583.457 114.532 583.884 114.02C584.269 113.559 584.813 113.3 585.7 113.3C586.15 113.3 586.477 113.368 586.734 113.482C586.989 113.595 587.205 113.767 587.416 114.02C587.843 114.532 588.1 115.12 588.1 116V163.7C588.1 164.58 587.843 165.168 587.416 165.68C587.036 166.135 586.397 166.4 585.6 166.4C584.771 166.4 584.112 166.085 583.498 165.297L552.1 123.301Z"
          fill="white"
          stroke="white"
          class="svg-elem-12"
        ></path>
        <path
          d="M613.9 117.8H613.4V118.3V136.8V137.3H613.9H637.7C638.532 137.3 639.078 137.485 639.446 137.854C639.864 138.271 640.1 138.748 640.1 139.4C640.1 140.052 639.864 140.529 639.446 140.946C639.078 141.315 638.532 141.5 637.7 141.5H613.9H613.4V142V161.4V161.9H613.9H639.2C640.032 161.9 640.606 162.085 640.988 162.39C641.343 162.675 641.6 163.215 641.6 163.9C641.6 164.552 641.364 165.029 640.946 165.446C640.578 165.815 640.032 166 639.2 166H610.9C610.115 166 609.448 165.741 608.954 165.246C608.447 164.74 608.2 164.168 608.2 163.4V116.1C608.2 115.332 608.447 114.76 608.954 114.254C609.427 113.78 609.977 113.6 610.9 113.6H639.2C640.032 113.6 640.578 113.785 640.946 114.154C641.364 114.571 641.6 115.048 641.6 115.7C641.6 116.352 641.364 116.829 640.946 117.246C640.578 117.615 640.032 117.8 639.2 117.8H613.9Z"
          fill="white"
          stroke="white"
          class="svg-elem-13"
        ></path>
        <path
          d="M40.6 52.9H41.0831L41.0997 52.4172C42.0905 23.585 65.7709 0.5 94.8 0.5H94.8018H94.8035H94.8053H94.807H94.8088H94.8105H94.8122H94.814H94.8157H94.8175H94.8192H94.8209H94.8227H94.8244H94.8261H94.8278H94.8296H94.8313H94.833H94.8347H94.8364H94.8381H94.8398H94.8415H94.8432H94.8449H94.8466H94.8483H94.85H94.8517H94.8534H94.8551H94.8568H94.8585H94.8602H94.8618H94.8635H94.8652H94.8669H94.8685H94.8702H94.8719H94.8735H94.8752H94.8769H94.8785H94.8802H94.8818H94.8835H94.8851H94.8868H94.8884H94.8901H94.8917H94.8933H94.895H94.8966H94.8983H94.8999H94.9015H94.9031H94.9048H94.9064H94.908H94.9096H94.9112H94.9129H94.9145H94.9161H94.9177H94.9193H94.9209H94.9225H94.9241H94.9257H94.9273H94.9289H94.9305H94.9321H94.9337H94.9353H94.9369H94.9384H94.94H94.9416H94.9432H94.9448H94.9463H94.9479H94.9495H94.951H94.9526H94.9542H94.9557H94.9573H94.9589H94.9604H94.962H94.9635H94.9651H94.9666H94.9682H94.9697H94.9713H94.9728H94.9744H94.9759H94.9774H94.979H94.9805H94.982H94.9836H94.9851H94.9866H94.9882H94.9897H94.9912H94.9927H94.9942H94.9958H94.9973H94.9988H95V132.9H40.5C18.3761 132.9 0.5 115.024 0.5 92.9C0.5 70.7769 18.3753 52.9 40.6 52.9Z"
          fill="#21C2EC"
          stroke="#21C2EC"
          class="svg-elem-14"
        ></path>
        <path
          d="M210.101 76.1318L210.148 76.8762L210.819 76.5495C214.655 74.6809 218.98 73.6 223.5 73.6C239.922 73.6 253.1 86.874 253.1 103.3C253.1 119.624 239.824 132.9 223.5 132.9H101.5H101V133.4V161V161.5H101.5H126.8C128.135 161.5 129.3 162.587 129.3 164C129.3 165.335 128.213 166.5 126.8 166.5H69.8C68.4652 166.5 67.3 165.413 67.3 164C67.3 162.665 68.3869 161.5 69.8 161.5H95.5H96V161V118.6V118.5V0.508973C118.271 1.00754 137.166 14.9157 144.935 34.5837L145.118 35.0463L145.581 34.866C150.927 32.7871 156.766 31.6 162.8 31.6C187.932 31.6 208.518 51.2913 210.101 76.1318ZM101 127.3V127.8H101.5H223.5C237.077 127.8 248.1 116.775 248.1 103.1C248.1 89.5239 237.076 78.5 223.5 78.5C219.923 78.5 216.349 79.3178 212.982 80.9501L212.976 80.9528C212.25 81.3159 211.427 81.5 210.6 81.5C209.553 81.5 208.564 81.3083 207.777 80.784L207.76 80.7727L207.743 80.7629C206.094 79.8471 205.091 78.2033 204.999 76.375L204.999 76.3684C203.582 54.0057 185.065 36.6 162.7 36.6C157.435 36.6 152.274 37.6127 147.319 39.5338L147.311 39.537L147.303 39.5404C146.686 39.8047 145.96 39.9 145.3 39.9C143.089 39.9 140.988 38.6115 140.168 36.4244L140.166 36.4198C136.729 27.5237 130.665 19.9462 122.789 14.3923C116.422 9.84473 109.146 7.01499 101.566 6.00439L101 5.92891V6.5V76.9V78.1278L101.858 77.2493L114.254 64.5536C114.254 64.5529 114.255 64.5522 114.256 64.5515C115.26 63.5488 116.842 63.5495 117.846 64.5536C118.851 65.5583 118.851 67.1417 117.846 68.1464L117.843 68.1496L101.043 85.2496L100.9 85.3955V85.6V108.7V109.927L101.758 109.049L127.054 83.1536C127.054 83.1529 127.055 83.1522 127.056 83.1515C128.082 82.1269 129.664 82.0706 130.646 83.0536C131.673 84.0801 131.73 85.6629 130.746 86.6464L130.742 86.6506L101.142 116.951L101 117.096V117.3V127.3Z"
          fill="white"
          stroke="white"
          class="svg-elem-15"
        ></path>
      </g>
    </svg>
  </div>
</template>

<style lang="scss">
  .logo-animation {
    width: 100%;
    svg {
      width: 100%;
      g {
        width: 100%;
      }
    }

    /***************************************************
    * Generated by SVG Artista on 10/4/2022, 5:24:41 PM
    * MIT license (https://opensource.org/licenses/MIT)
    * W. https://svgartista.net
    **************************************************/
    svg .svg-elem-1 {
      stroke-dashoffset: 233.9306182861328px;
      stroke-dasharray: 233.9306182861328px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s;
    }

    svg.active .svg-elem-1 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-2 {
      stroke-dashoffset: 275.0412292480469px;
      stroke-dasharray: 275.0412292480469px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.9s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.9s;
    }

    svg.active .svg-elem-2 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-3 {
      stroke-dashoffset: 370.1684265136719px;
      stroke-dasharray: 370.1684265136719px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.24s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.24s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1s;
    }

    svg.active .svg-elem-3 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-4 {
      stroke-dashoffset: 257.70086669921875px;
      stroke-dasharray: 257.70086669921875px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.36s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.36s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s;
    }

    svg.active .svg-elem-4 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-5 {
      stroke-dashoffset: 114.43339538574219px;
      stroke-dasharray: 114.43339538574219px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.48s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2000000000000002s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.48s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2000000000000002s;
    }

    svg.active .svg-elem-5 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-6 {
      stroke-dashoffset: 318.26019287109375px;
      stroke-dasharray: 318.26019287109375px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.6s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.6s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3s;
    }

    svg.active .svg-elem-6 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-7 {
      stroke-dashoffset: 300.366455078125px;
      stroke-dasharray: 300.366455078125px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.72s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4000000000000001s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.72s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.4000000000000001s;
    }

    svg.active .svg-elem-7 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-8 {
      stroke-dashoffset: 296.0816955566406px;
      stroke-dasharray: 296.0816955566406px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.84s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.5s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.84s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.5s;
    }

    svg.active .svg-elem-8 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-9 {
      stroke-dashoffset: 318.2538757324219px;
      stroke-dasharray: 318.2538757324219px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.96s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.6s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.96s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.6s;
    }

    svg.active .svg-elem-9 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-10 {
      stroke-dashoffset: 167.62008666992188px;
      stroke-dasharray: 167.62008666992188px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.08s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7000000000000002s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.08s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7000000000000002s;
    }

    svg.active .svg-elem-10 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-11 {
      stroke-dashoffset: 114.42289733886719px;
      stroke-dasharray: 114.42289733886719px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.8s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.8s;
    }

    svg.active .svg-elem-11 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-12 {
      stroke-dashoffset: 318.26104736328125px;
      stroke-dasharray: 318.26104736328125px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3199999999999998s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.9000000000000001s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3199999999999998s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.9000000000000001s;
    }

    svg.active .svg-elem-12 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-13 {
      stroke-dashoffset: 275.98114013671875px;
      stroke-dasharray: 275.98114013671875px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.44s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.44s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2s;
    }

    svg.active .svg-elem-13 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-14 {
      stroke-dashoffset: 398.44317626953125px;
      stroke-dasharray: 398.44317626953125px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.56s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.1s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.56s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.1s;
    }

    svg.active .svg-elem-14 {
      stroke-dashoffset: 0;
      fill: rgb(33, 194, 236);
    }

    svg .svg-elem-15 {
      stroke-dashoffset: 1308.5399169921875px;
      stroke-dasharray: 1308.5399169921875px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.68s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.2s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.68s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.2s;
    }

    svg.active .svg-elem-15 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }

    svg .svg-elem-16 {
      stroke-dashoffset: 1620.39990234375px;
      stroke-dasharray: 1620.39990234375px;
      fill: transparent;
      -webkit-transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7999999999999998s,
                            fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s;
              transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 1.7999999999999998s,
                    fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 2.3s;
    }

    svg.active .svg-elem-16 {
      stroke-dashoffset: 0;
      fill: rgb(255, 255, 255);
    }
  }
</style>

<script>
export default {
  name: 'AccessCardIcon',
  props: {
    loading: Boolean
  },
  data: () => ({
    intervalHandler: null,
    startTimeout: null,
    active: false
  }),
  computed: {},
  methods: {
    start: function () {
      const vm = this
      clearTimeout(this.startTimeout)
      clearInterval(this.intervalHandler)
      this.startTimeout = setTimeout(() => {
        vm.active = vm.loading && !vm.active
        vm.intervalHandler = setInterval(function () {
          vm.active = vm.loading && !vm.active
        }, 3000)
      }, 500)
    },
    stop: function () {
      clearTimeout(this.startTimeout)
      this.startTimeout = null
      clearInterval(this.intervalHandler)
      this.intervalHandler = null
      this.active = true
    }
  },
  watch: {
    loading: function () {
      if (!this.loading) {
        this.stop()
      } else {
        this.start()
      }
    }
  },
  mounted () {
    if (!this.loading) {
      this.stop()
    } else {
      this.start()
    }
  },
  destroyed () {
    this.stop()
  }
}
</script>
